import React, { useEffect, useState } from 'react'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { getAttendanceByEmail } from '../firebase/utils';
import { Button, Modal, Spin } from 'antd';

const CalenderModal = ({ showCalenderModal, closeModal, email, selectedCourse }) => {
    const [attendance, setAttendance] = useState({});
    const [studentAttendance, setStudentAttendance] = useState({});
    const [isLoading, setLoading] = useState(true);

    const updateAttendance = (data) => {
        const updatedAttendance = {};

        data.forEach((doc) => {
            const attendanceData = doc;
            const { attendanceDate, status } = attendanceData;
            updatedAttendance[attendanceDate] = status;
        });
        setAttendance(updatedAttendance);
        setLoading(false);
        checkTotalDays(updatedAttendance)
    };

    const checkTotalDays = (attendance) => {
        const startDate = new Date(selectedCourse.startDate);
        const endDate = new Date(selectedCourse.endDate);
        const days = selectedCourse.days;
        const today = new Date();
        const classDays = days.toUpperCase().split(/[ &]+/);
        let current = new Date(startDate);
        let totalDaysFromStart = 0;
        let totalCourseClasses = 0;
        let currentDate = new Date(startDate);
        let currentDateCount = new Date(startDate);
        let present = 0;
        let absent = 0;
        let leave = 0;
        let totalClassesTillDate = 0;

        // Calculate total number of class days
        while (currentDate <= endDate) {
            if (classDays.includes(currentDate.toLocaleString("en-US", { weekday: "short" }).toUpperCase())) {
                totalCourseClasses++;
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        // Calculate number of class days from start date until today
        current = new Date(startDate);
        while (current <= today) {
            if (classDays.includes(current.toLocaleString("en-US", { weekday: "short" }).toUpperCase())) {
                totalDaysFromStart++;
            }
            current.setDate(current.getDate() + 1);
        }

        // Calculate attendance for each day and total attendance till date
        currentDateCount = new Date(startDate);
        while (currentDateCount <= endDate) {
            const dateString = currentDateCount.toISOString().split('T')[0];
            const status = attendance[dateString];
            if (status === 'present') {
                present++;
            } else if (status === 'absent') {
                absent++;
            } else if (status === 'leave') {
                leave++;
            }
            currentDateCount.setDate(currentDateCount.getDate() + 1);
        }
        totalClassesTillDate = present + absent + leave;

        // Adjust absent count if necessary
        if (totalDaysFromStart > totalClassesTillDate) {
            absent = absent + (totalDaysFromStart - totalClassesTillDate);
        }
        setStudentAttendance({
            present,
            absent,
            leave,
            totalClassesTillDate: totalDaysFromStart,
            totalCourseClasses
        })
    }

    useEffect(() => {
        getAttendanceByEmail(email).then((data) => {
            updateAttendance(data);
        });
    }, [])

    const tileContent = ({ date }) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const attendanceData = attendance[`${year}-${month}-${day}`];
        if (attendanceData) {
            let colorClass, tooltip;
            if (attendanceData === 'present') {
                colorClass = '#198754';
                tooltip = 'Present';
            } else if (attendanceData === 'absent') {
                colorClass = '#dc3545';
                tooltip = 'Absent';
            } else if (attendanceData === 'leave') {
                colorClass = '#ffc107';
                tooltip = 'Leave';
            }

            return (
                <div
                    className="rounded-circle mx-auto mt-1 d-block"
                    style={{
                        width: '0.5rem',
                        height: '0.5rem',
                        backgroundColor: colorClass,
                    }}
                    title={tooltip}
                />
            );
        }
        return null;
    };
    const renderAttendanceStatus = () => {
        const headings = <thead className="bg-dark text-uppercase text-light">
            <tr>
                {Object?.keys(studentAttendance)?.map(function (key) {
                    return <th key={key} scope="col" className="py-3 px-4 text-center">
                        {key}
                    </th>
                })}
            </tr>
        </thead>

        const body = <tbody>
            <tr className="bg-dark text-light">
                {Object?.keys(studentAttendance)?.map(function (key, i) {
                    return <td key={`key-${i}`} className="py-3 px-4 text-center">{studentAttendance[key]}</td>
                })}
            </tr>
        </tbody>

        return [headings, body]
    }
    return (
        <Modal
            open={showCalenderModal}
            onCancel={closeModal}
            centered
            width={750}
            footer={null}
            className='rounded'
        >
            <div>
                <p className="text-center fs-5 text-dark my-2">
                    Attendance Calender
                </p>
            </div>
            <div className="w-100">
                {isLoading ? <div className="d-flex justify-content-center align-items-center"><Spin /></div> :
                    <>
                        <div className="table-responsive theme-scrollbar invoice-table" id="table">
                            <table className="table table-light table-bordered rounded">
                                {renderAttendanceStatus()}
                            </table>
                        </div>
                        <Calendar tileContent={tileContent} defaultValue={new Date()} className="w-100 border-0" />
                        <div className='d-flex justify-content-end align-items-center w-100 me-10 mt-4'>
                            <Button onClick={closeModal} type="primary" className='rounded'>
                                Close
                            </Button>
                        </div>
                    </>}
            </div>
        </Modal>
    )
}

export default CalenderModal